import { CUSTOMER_TYPES } from '../../../lib/constants';

const FIRST_CUSTOMER_DELAY_MS = 1500;

const CUSTOMER_AVATAR_ANIMATION_DURATION_MS = 300;
const CUSTOMER_AVATAR_ANIMATION_DURATION_S = CUSTOMER_AVATAR_ANIMATION_DURATION_MS / 1000;

const CUSTOMER_PURCHASE_CARD_ANIMATION_DELAY_MS = CUSTOMER_AVATAR_ANIMATION_DURATION_MS + 400;
const CUSTOMER_PURCHASE_CARD_ANIMATION_DELAY_S = CUSTOMER_PURCHASE_CARD_ANIMATION_DELAY_MS / 1000;

const CUSTOMER_PURCHASE_CARD_ANIMATION_DURATION_MS = 1200;
const CUSTOMER_DELAY_BEFORE_NEXT_CUSTOMER = 400;

const CUSTOMER_TOTAL_ANIMATION_DURATION_MS = 
	CUSTOMER_DELAY_BEFORE_NEXT_CUSTOMER + 
	CUSTOMER_AVATAR_ANIMATION_DURATION_MS +
	CUSTOMER_PURCHASE_CARD_ANIMATION_DURATION_MS;

const CUSTOMER_TOTAL_ANIMATION_DURATION_S = CUSTOMER_TOTAL_ANIMATION_DURATION_MS / 1000;
const EXTRA_CUSTOMERS_BUTTON_DELAY_MS = 1000;

const CUSTOMER_REPLACEMENT_DELAY_MS = 900;

const BARGAINING_TIME = 4000;

const CUSTOMER_ANIMATION_STATE = {
	WAITING_TO_APPEAR: 'waitingToAppear',
	IDLE: 'idle',
	IDLE_NO_SELL: 'idle_no_sell',
	SOLD: 'sold',
	SOLD_SALESMAN: 'sold_salesman',
	DISMISSED: 'dismissed',
	CLEARED: 'cleared' // When clicking 'request more customers' button
};

const CUSTOMER_APPEARANCE_GROUP = {
	[CUSTOMER_TYPES.FIXED_PRICE]: 0,
	[CUSTOMER_TYPES.WHATEVER_PRICE]: 0,
	[CUSTOMER_TYPES.CREDIT]: 0,
	[CUSTOMER_TYPES.BARGAINING]: 1,
	[CUSTOMER_TYPES.LAZY]: 2
};

export {
	CUSTOMER_ANIMATION_STATE,
	FIRST_CUSTOMER_DELAY_MS,
	CUSTOMER_AVATAR_ANIMATION_DURATION_S,
	CUSTOMER_REPLACEMENT_DELAY_MS,
	BARGAINING_TIME,
	CUSTOMER_AVATAR_ANIMATION_DURATION_MS,
	CUSTOMER_PURCHASE_CARD_ANIMATION_DURATION_MS,
	CUSTOMER_PURCHASE_CARD_ANIMATION_DELAY_S,
	CUSTOMER_TOTAL_ANIMATION_DURATION_S,
	CUSTOMER_TOTAL_ANIMATION_DURATION_MS,
	EXTRA_CUSTOMERS_BUTTON_DELAY_MS,
	CUSTOMER_APPEARANCE_GROUP
};
